// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__29ozV","bigColWidth":"Table_bigColWidth__c9DLA","biggerColWidth":"Table_biggerColWidth__1H6Dj","row":"Table_row__1JOod","col":"Table_col__1j23_"};